/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_Non_FinalistsInputs */



/**
* | output |
* | --- |
* | "Non-finalists" |
*
* @param {Raffle_Pool_Non_FinalistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_non_finalists = /** @type {((inputs?: Raffle_Pool_Non_FinalistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_Non_FinalistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non-finalistes")
	if (locale === "es") return /** @type {LocalizedString} */ ("No finalistas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não finalistas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non finalisti")
	return /** @type {LocalizedString} */ ("Non-finalists")
});